export default __webpack_public_path__ + "static/media/dummy-chart.8c519422.png";